import { FormControl } from '@angular/forms';

export function containsNumberValidator(formControl: FormControl) {
  const CONTAINS_NUMBER_REGEX = /\d/;

  return CONTAINS_NUMBER_REGEX.test(formControl.value) ? null : {
    containsNumber: {
      valid: false
    }
  }
}
